import { useStudentLogonAccess } from "../../api/getStudentLogonAccess";
import {
  CircularProgress,
  Container,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import CustomTable from "../../../../ui/components/Table";

const StudentLogons = ({ studentId, courseId }) => {
  const { data, isLoading } = useStudentLogonAccess({ studentId, courseId });
  if (isLoading) {
    return <CircularProgress />;
  }

  return (
    <CustomTable>
      <TableHead>
        <TableRow>
          <TableCell>
            <Typography>Data</Typography>
          </TableCell>
          <TableCell>
            <Typography>Tempo conectado</Typography>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data?.map((access) => {
          return (
            <TableRow>
              <TableCell>
                <Typography>
                  {moment(access.dtLogon, "DD-MM-YYYY HH:mm:ss")
                    .locale("pt-br")
                    .format("lll")}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography>{access.onlineTime} minutos</Typography>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </CustomTable>
  );
};

export { StudentLogons };
